import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_pay_wrkrs_correctly_for_any_of_these_type'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_pay_wrkrs_correctly_for_any_of_these_type',
  name: 'Is the facility failing to pay workers correctly for any of these types of overtime hours, as legally required: \r\r\n• Ordinary overtime hours\r\r\n• Overtime hours performed at night\r\r\n• Overtime hours performed on weekly rest days\r\r\n• Overtime hours performed on public holidays?',
  description:
    'Answer No if the facility is paying all workers correctly for all types of overtime hours as legally required.\r\r\n\r\r\nEmployers typically are required to pay a higher rate for hours worked during overtime. \r\r\n\r\r\nThe intent of this question is to understand if the facility\'s overtime wages are in line with legal requirements. \r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\n"Ordinary overtime hours" are those hours performed AFTER meeting regular daily, weekly, or monthly requirements (e.g. after 8, after 40, etc.). They do not include overtime hours performed at night, on weekly rest days, or on public holidays.\r\r\n\r\r\nConsult applicable legal requirements to determine what constitutes "overtime hours performed at night", as well as the legally required payment.\r\r\n\r\r\nConsult applicable legal requirements to determine what constitutes "overtime hours performed on weekly rest days", as well as the legally required payment.\r\r\n\r\r\nConsult applicable legal requirements to determine what constitutes "overtime hours performed on public holidays", as well as the legally required payment.\r\r\n',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wag-12',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7440,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
